
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-900 text-white sticky top-0 z-50">
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/19e1ae871b27e79d86366822ce3eb7e6/a6945231c8e9a49508302bb936026862.png" 
              alt="A&R Electric Logo" 
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Home</a>
            <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Services</a>
            <a href="#about" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">About</a>
            <a href="#projects" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Projects</a>
            <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Contact</a>
            <Button size="sm">Get Quote</Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-700 pt-4">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Home</a>
              <a href="#services" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Services</a>
              <a href="#about" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">About</a>
              <a href="#projects" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Projects</a>
              <a href="#contact" className="hover:text-yellow-400 transition-colors cursor-pointer text-lg">Contact</a>
              <Button size="sm" className="w-fit">Get Quote</Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}